import DateTimePicker from "@/modules/common/components/ui/date-picker/date-time-picker";
import { Box } from "@mui/material";

const EditDateOfLastContact = ({
  autoFocus,
  dateOfLastContact,
}: {
  autoFocus?: boolean;
  dateOfLastContact: {
    state: Date | Date[] | null | string;
    setDateOfLastContact: (date: Date | Date[] | null | string) => void;
  };
}) => {
  const isValidDate = (date: Date | Date[] | null | string) => {
    return date instanceof Date && !isNaN(date.getTime());
  };

  const getDateValue = (date: Date | Date[] | null | string) => {
    const dateValue = typeof date === "string" ? new Date(date) : date;
    return isValidDate(dateValue) ? dateValue : null;
  };

  const dateValue = getDateValue(dateOfLastContact.state);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <DateTimePicker
        date={
          dateValue && !(dateValue instanceof Array)
            ? new Date(dateValue)
            : null
        }
        defaultValue={
          dateValue && !(dateValue instanceof Array)
            ? new Date(dateValue)
            : undefined
        }
        setDate={dateOfLastContact.setDateOfLastContact}
        label="Date of Last Contact"
        maxDate={new Date()}
        autoFocus={autoFocus}
        ignoreTopPadding={false}
      />
    </Box>
  );
};

export default EditDateOfLastContact;
